var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6 17.9994C1.55425 17.9994 1.50805 17.9941 1.4623 17.9833C1.33077 17.9513 1.21359 17.8747 1.12971 17.766C1.04582 17.6573 1.00013 17.5227 1 17.3841C1 11.7922 1.6897 7.14162 10 6.93009V2.61529C10 2.49565 10.034 2.37861 10.0979 2.27849C10.1618 2.17837 10.2527 2.09951 10.3596 2.05157C10.4664 2.00363 10.5846 1.98868 10.6997 2.00855C10.8147 2.02842 10.9216 2.08225 11.0072 2.16346L18.8072 9.54785C18.9302 9.66369 19 9.82784 19 9.99968C19 10.1715 18.9302 10.3357 18.8072 10.4517L11.0072 17.8361C10.9217 17.9176 10.8147 17.9716 10.6996 17.9915C10.5844 18.0114 10.4661 17.9962 10.3592 17.9479C10.2524 17.8999 10.1616 17.821 10.0978 17.7208C10.034 17.6207 10 17.5037 10 17.3841V13.0837C4.2994 13.2237 3.2476 15.3806 2.1367 17.6593C2.08689 17.7615 2.01029 17.8475 1.91549 17.9076C1.82069 17.9677 1.71144 17.9995 1.6 17.9994ZM10.6 11.8458C10.9317 11.8458 11.2 12.121 11.2 12.4611V15.9784L17.5153 9.99968L11.2 4.02094V7.53822C11.2 7.87836 10.9317 8.15359 10.6 8.15359C3.9718 8.15359 2.54455 10.7827 2.2639 14.9822C3.50665 13.27 5.6248 11.8458 10.6 11.8458Z",
    fill: "#946BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.01c8b69eb07c06ad553a5e29e084d77f.svg";
export { ForwardRef as ReactComponent };